import { AttributesMixin, define } from "@type-r/models";
import { restfulIO } from "./endpoint";
import { PolicyCardBase } from "./policyCardBase";

export interface PolicyCardDraft extends AttributesMixin<typeof PolicyCardDraft> { }

@define
export class PolicyCardDraft extends PolicyCardBase {
    static endpoint = restfulIO('api/v1/ingest/invoices/linking/policies/draft');

    static attributes = {
        ...PolicyCardBase.attributes
    }}
